import type { SearchSliceNode } from '@/analysis/searchContract'

export type Dimension =
  | 'stream'
  | 'continent'
  | 'country'
  | 'region'
  | 'studio'
  | 'game'
  | 'brand'
  | 'device_type'
  | 'browser'
  | 'cdn_edge'
  | 'user'

/** Worst severity first, then average. Nulls sort last. */
export const compareRowsBySeverity = (a: SearchSliceNode, b: SearchSliceNode): number => {
  const aw = a.worstMetricSeverity ?? null
  const bw = b.worstMetricSeverity ?? null
  if (aw !== bw) {
    if (aw === null) return 1
    if (bw === null) return -1
    return aw - bw
  }
  const aa = a.avgSeverity
  const ba = b.avgSeverity
  if (aa === ba) return 0
  if (aa === null) return 1
  if (ba === null) return -1
  return aa - ba
}
